import { useEffect, useState } from "react";
import {
  deleteInventoryMatchRule,
  listInventoryMatchRules,
  type InventoryMatchRule,
} from "@/lib/manufacturing/inventoryMatchClient";

export function useOrderMappingSkuRules(onError: (message: string | null) => void) {
  const [skuRules, setSkuRules] = useState<InventoryMatchRule[]>([]);

  useEffect(() => {
    void listInventoryMatchRules().then((out) => {
      if (!out.ok) {
        onError(out.error);
        return;
      }
      setSkuRules(out.data.rules.filter((rule) => rule.is_active));
    });
  }, [onError]);

  function addSkuRules(rules: readonly InventoryMatchRule[]) {
    setSkuRules((prev) => {
      const ids = new Set(rules.map((rule) => rule.id));
      return [...prev.filter((rule) => !ids.has(rule.id)), ...rules];
    });
  }

  async function removeSkuRule(id: string) {
    const out = await deleteInventoryMatchRule(id);
    if (!out.ok) {
      onError(out.error);
      return;
    }
    setSkuRules((prev) => prev.filter((rule) => rule.id !== id));
  }

  return { skuRules, addSkuRules, removeSkuRule };
}
